import {
  APPLY_PRESET,
  CHANGE_LOCATION,
  SEARCH,
  SET_FILTERS,
  SET_TABLE_SETTINGS,
} from '@gogame/screens';

import { tableSettingsSchema as conceptFamiliesTableSettings } from 'scenes/Gallery/GalleryPage/ConceptFamilies/schemas/tableSettingsSchema';
import { tableSettingsSchema as conceptsTableSettings } from 'scenes/Gallery/GalleryPage/Concepts/schemas/tableSettingsSchema';
import { tableSettingsSchema as creativesTableSettings } from 'scenes/Gallery/GalleryPage/Creatives/schemas/tableSettingsSchema';
import {
  REORDER_COLUMNS,
  COLLAPSE_COLUMNS,
  SCOPE_CREATIVES,
  SCOPE_CONCEPTS,
  SCOPE_CONCEPT_FAMILIES,
} from 'scenes/Gallery/GalleryPage/constants';

import { mapPresetToState } from './schemas';

export const SET_SEARCH_TYPE = 'SET_SEARCH_TYPE';

export default function screenReducer(state = { ready: false }, action) {
  const oldScopeState = state?.[action?.scope];
  switch (action.type) {
    case REORDER_COLUMNS:
      return {
        ...state,
        [action.scope]: {
          ...oldScopeState,
          columns: {
            ...oldScopeState.columns,
            order: action.payload,
          },
        },
      };

    case COLLAPSE_COLUMNS:
      return {
        ...state,
        [action.scope]: {
          ...oldScopeState,
          columns: {
            ...oldScopeState.columns,
            collapsed: action.payload,
          },
        },
      };

    case SET_TABLE_SETTINGS:
      return {
        ...state,
        [action.scope]: {
          columns: oldScopeState.columns,
          tableSettings: {
            ...state[action.scope].tableSettings,
            ...action.payload,
          },
        },
      };
    case SET_FILTERS:
      return {
        ...state,
        [SCOPE_CREATIVES]: {
          ...state[SCOPE_CREATIVES],
          tableSettings: {
            ...creativesTableSettings.default(),
            limit: state[SCOPE_CREATIVES].tableSettings.limit,
          },
        },
        [SCOPE_CONCEPTS]: {
          ...state[SCOPE_CONCEPTS],
          tableSettings: {
            ...conceptsTableSettings.default(),
            limit: state[SCOPE_CONCEPTS].tableSettings.limit,
          },
        },
        [SCOPE_CONCEPT_FAMILIES]: {
          ...state[SCOPE_CONCEPT_FAMILIES],
          tableSettings: {
            ...conceptFamiliesTableSettings.default(),
            limit: state[SCOPE_CONCEPT_FAMILIES].tableSettings.limit,
          },
        },
        filters: action.payload,
      };
    case APPLY_PRESET:
      if (action.payload) {
        const { id, data } = action.payload;
        const { applyPresetData } = action.meta;
        return {
          ...(applyPresetData ? mapPresetToState(data) : state),
          presetId: id,
        };
      }
      return {
        ...state,
        presetId: undefined,
      };

    case SET_SEARCH_TYPE:
    case SEARCH:
      const newState = {
        ...state,
        [SCOPE_CREATIVES]: {
          ...state[SCOPE_CREATIVES],
          tableSettings: {
            ...creativesTableSettings.default(),
            limit: state[SCOPE_CREATIVES].tableSettings.limit,
          },
        },
        [SCOPE_CONCEPTS]: {
          ...state[SCOPE_CONCEPTS],
          tableSettings: {
            ...conceptsTableSettings.default(),
            limit: state[SCOPE_CONCEPTS].tableSettings.limit,
          },
        },
        [SCOPE_CONCEPT_FAMILIES]: {
          ...state[SCOPE_CONCEPT_FAMILIES],
          tableSettings: {
            ...conceptFamiliesTableSettings.default(),
            limit: state[SCOPE_CONCEPT_FAMILIES].tableSettings.limit,
          },
        },
        presetId: undefined,
      };

      return {
        ...newState,
        ...(action.type === SEARCH
          ? { searchQuery: action.payload.query }
          : null),
        ...(action.type === SET_SEARCH_TYPE
          ? {
              searchType: action.payload.type,
              searchQuery: action.payload.query,
            }
          : null),
      };

    case CHANGE_LOCATION:
      // url state
      return action.payload;

    default:
      return state;
  }
}
